// extracted by mini-css-extract-plugin
export default {"overlay":"BB-z","bodyOpen":"CB-z","content":"DB-z","header":"EB-z","close":"FB-z","closeNoHeading":"GB-z"};